export const sortByOrderingIndex = (
	a: { ordering_index: number },
	b: { ordering_index: number },
) => b.ordering_index - a.ordering_index;
